<div class="card">
  <mat-tab-group
    (selectedTabChange)="alloyJourneyTabChange($event)"
    [selectedIndex]="activeTabIndex"
    *ngIf="applicantRequests.length > 0"
  >
    <div *ngFor="let applicantRequest of applicantRequests">
      <mat-tab
        label="{{ applicantRequest.firstName }} {{ applicantRequest.lastName }}"
        id="applicantTab_{{ applicantRequest.applicantId }}"
      >
      </mat-tab>
    </div>
  </mat-tab-group>
  <div
    *ngFor="
      let applicantRequest of applicantRequests;
      let indexOfElements = index
    "
  >
    <div
      class="applicant-tab-area"
      [hidden]="indexOfElements != activeTabIndex"
      fxFlex
      fxLayout="column"
      fxLayoutAlign="start center"
      aria-live="polite"
      role="status"
    >
      <ng-container *ngIf="alloyFrameIsNotLoadedMap.get(applicantRequest.applicantId!)">
        <div class="loading-alloy" fxLayout="column" fxLayoutAlign="center center" class="processing-card card">
          <div id="processing-logo-area">&nbsp;</div>
    
          <div class="detail-header">Your application is currently being reviewed.</div>
          <div class="detail-header">Please do not refresh this page.</div>
          <br/>
          <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
        </div>
      </ng-container>
      <div
        id="alloy-initial-dialog"
        *ngIf="alloyJourneyApplicantStatusMap.has(applicantRequest.applicantId!)
        && !alloyFrameIsNotLoadedMap.get(applicantRequest.applicantId!)
        && !alloyJourneyApplicantStatusMap.get(applicantRequest.applicantId!)!.status"
      >
        <div
          fxLayout
          fxLayout.xs="column"
          fxLayoutAlign="center"
          fxLayoutGap="50px"
          fxLayoutGap.xs="0"
        >
          <div class="alloy-sub-area">
            <h3><div class="alloy-sub-label">Continue on your phone</div></h3>
            <br /><br />
            <div class="alloy-sub-label-detail">Link has been sent to:</div>
            <div>
              <span class="phone-number-area">{{
                applicantRequest.phoneNumber! | mask : "000-000-0000"
              }}</span>
            </div>
            <br />
          </div>
          <h3><div class="option-label">or</div></h3>
          <div class="alloy-sub-area">
            <h3>
              <div class="alloy-sub-label">Didn't receive the text?</div>
            </h3>
            <br /><br />
            <div class="alloy-sub-label-detail">Use this QR Code:</div>
            <div>
              <img
                class="alloy-qr-code"
                [src]="
                  sanitizeImageUrl(
                    alloyJourneyApplicantStatusMap.get(applicantRequest.applicantId!)!
                      .qrCode!
                  )
                "
                alt="Document Capture QR Code"
              />
            </div>
          </div>
        </div>
      </div>
      <!--TODO: Review the incomming webhooks to determine if this is possible-->
      <!-- <div
        id="alloy-progress-dialog"
        *ngIf="
          alloyJourneyApplicantStatusMap.has(applicantRequest.applicantId!) &&
          alloyJourneyApplicantStatusMap.get(applicantRequest.applicantId!)!.status ==
            'WAITING_FOR_DOCUMENT_UPLOAD'
        "
      >
        <div
          role="img"
          aria-label="Document capture is in process"
          id="document-update-in-progress-area"
        >
          &nbsp;
        </div>
      </div> -->

      <div
        id="applicant-finished-dialog"
        *ngIf="
          applicantRequests.length > 1 
          && isDocumentUploadFinished(applicantRequest)
        "
      >
        <div class="checkbox-area">
          <mat-icon
            class="completedCheckmark icon-centered document-upload-complete-icon"
            svgIcon="check_circle"
          ></mat-icon>
        </div>
        <div class="alloy-sub-label">Document Upload Complete</div>
        <br /><br />
        <div class="alloy-sub-label-detail" *ngIf="indexOfElements === 0">
          Please wait for {{ applicantRequests[1].firstName }}
          {{ applicantRequests[1].lastName }} to complete the upload process.
        </div>
        <div class="alloy-sub-label-detail" *ngIf="indexOfElements === 1">
          Please wait for {{ applicantRequests[0].firstName }}
          {{ applicantRequests[0].lastName }} to complete the upload process.
        </div>
      </div>
    </div>
  </div>
</div>
